import { useBrokerContextSafe } from '@/app/context';
import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import type {
  RdClientPayload,
  RdProposal,
} from '@/services/quotes/rd-equipamentos/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/** Cria a proposta RD Equipamentos (Step 1 — Cliente). */
export function useCreateRdProposal() {
  const queryClient = useQueryClient();
  const broker = useBrokerContextSafe();

  return useMutation<RdProposal, Error, RdClientPayload>({
    mutationKey: ['quotes', 'create', 'rd-equipamentos'],
    mutationFn: async (payload: RdClientPayload) => {
      const response = await rdEquipamentosService.createProposal(
        payload,
        broker?.selectedBroker?.code
      );
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao criar proposta');
      }

      return response.data;
    },
    // Semeia o cache da query de detalhes com a proposta recém-criada para que
    // o próximo step já leia o `productType` correto no primeiro render
    // pós-navegação — evita o render intermediário em que `proposal` está
    // indefinido, `productType` cai para 'individual' e o guard do wizard
    // redirecionaria o fluxo agregado (FLEET) de volta ao Step 1 (Cliente).
    onSuccess: data => {
      queryClient.setQueryData(['rd-proposal', data.proposalId], data);
    },
  });
}
